import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import ListGeometryTypeRevisions from "../ListGeometryTypeRevisions.graphql";
import RevisionInventory from "./RevisionInventory";

export default function Revisions(props) {
    const { guard, id, revisionID } = props;

    const listGeometryTypeRevisions = useQuery(
        gql(ListGeometryTypeRevisions),
        {
            variables: {
                id,
            },
        },
    );

    if (listGeometryTypeRevisions.loading) return "loading";
    if (listGeometryTypeRevisions.error) return "error";

    return (
        <RevisionInventory
            guard={ guard }
            revisions={ listGeometryTypeRevisions.data?.geometryType?.revisions }
            selectedRevisionID={ revisionID }
        />
    );
}
